import moment, { Moment } from 'moment';

export const today = (now?: Moment) => (now ? now.clone() : moment()).utc().startOf('day');
export const yesterday = (now?: Moment) => today(now).subtract(1, 'days');

export function formatDate(date: Moment) {
  return date.format('LL');
}

export function generateDateRange(startDate: Moment, endDate: Moment, locale: string) {
  return `${formatDate(moment(startDate).locale(locale))} - ${formatDate(
    moment(endDate).locale(locale),
  )}`;
}

export function formatDateForApi(momentDate: Moment) {
  return momentDate.utc().format('YYYY-MM-DD');
}

export function getDateFormat() {
  return moment.localeData().longDateFormat('L');
}
